module.exports = __webpack_public_path__ + "fonts/SH-Bree-HeadlineEUR.3e4b287f.woff2";